import { render, staticRenderFns } from "./Reception-history.vue?vue&type=template&id=e25a3b4a&"
import script from "./Reception-history.vue?vue&type=script&lang=js&"
export * from "./Reception-history.vue?vue&type=script&lang=js&"
import style0 from "./Reception-history.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports